import { useTranslation } from "@redotech/redo-i18n";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const InStorePackingSlipButton = memo(function InStorePackingSlipButton({
  packingSlipLink,
  onOpenUrl,
}: {
  packingSlipLink: string | undefined;
  onOpenUrl: (url: string) => void;
}) {
  const { t } = useTranslation();
  if (!packingSlipLink) {
    return null;
  }

  return (
    <Flex>
      <RedoButton
        hierarchy="secondary"
        onClick={() => onOpenUrl(packingSlipLink)}
        text={t("Print return authorization")}
      />
    </Flex>
  );
});
